// @flow
import React from 'react';
import NotificationsSystem from 'reapop';

import ConfirmationModal from './components/modaleNotification/ConfirmationModal';
import theme from './components/modaleNotification/theme/index';
import Header from './pages/home/Header';
import ModalMediaCarousel from './pages/common/ModalMediaCarousel';

import './utils/polyfill_startswith';
import './utils/polyfill_includes';
import MainContent from './pages/home/MainContent';

function App() {
  return (
    /* eslint-disable react/jsx-filename-extension */
    <div id="app">
      <NotificationsSystem theme={theme} />
      <ConfirmationModal />
      <ModalMediaCarousel />
      <div className="apollo">
        <Header />
        <main id="main-content">
          <MainContent />
        </main>
      </div>
    </div>
  );
}

export default App;
